<mat-card class="mat-elevation-z8">
    <form [formGroup]="vehicle_register_from">
        <!-- user details -->
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Vehicle Transport Name<i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='vehicle_transport_id'>
                        <option *ngFor="let vehicle_transport of vehicle_transports" [value]="vehicle_transport['id']">
                            {{vehicle_transport['name']}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col">
              <div class="form-group">
                  <label for="exampleFormControlSelect1">Vehicle Type <i class="material-icons"
                          style="color: red;font-size: 14px;">star</i></label>
                  <select class="form-control dropdown_box" formControlName='vehicle_type_id'>
                      <option *ngFor="let vehicle_type of vehicle_types" [value]="vehicle_type['id']">
                          {{vehicle_type['name']}}
                      </option>
                  </select>
              </div>
          </div>
        </div>
        <div class="row">

            <div class="col">
                <div class="form-group">
                    <label>Vehicle Number <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="text" class="form-control code_box" formControlName='licence_number'>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Capacity in Kg <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="number" class="form-control code_box" formControlName='capacity_in_kg'>
                </div>
            </div>
            <div class="col">
              <div class="form-group">
                  <label>Tray Capacity<i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                  <input type="number" class="form-control code_box" formControlName='tray_capacity'>
              </div>
          </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Fc Expiry date and time<i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <input type="datetime-local" class="form-control code_box" formControlName='fc_expiry_date'>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlFile1">Fc Document</label>
                    <input type="file" class="form-control-file" id="exampleFormControlFile1"
                        (change)="fctoBase64($event)" accept="image/*" formControlName='fc_document'>
                </div>
            </div>
            <div class="col" *ngIf="fc_document != null">
                <img [src]="fc_document" style="height: 100px;">
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Insurance Expiry date and time <i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <input type="datetime-local" class="form-control code_box" formControlName='insurance_expiry_date'>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlFile1">Insurance Document</label>
                    <input type="file" class="form-control-file" id="exampleFormControlFile1"
                        (change)="insurancetoBase64($event)" accept="image/*" formControlName='insurance_document'>
                </div>
            </div>
            <div class="col" *ngIf="insurance_document != null">
                <img [src]="insurance_document" style="height: 100px;">
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>driver Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="text" class="form-control code_box" formControlName='driver_name'>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Driver Mobile <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="number" class="form-control code_box" formControlName='mobile'>
                    <div style="font-style: italic; font-size: small; color:red"
                        *ngIf="vehicle_register_from.controls.mobile.errors !== null">
                        {{ vehicle_register_from.controls.mobile.errors['error']}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                    <label for="exampleFormControlFile1">Contract starts from <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                <input type="datetime-local" class="form-control code_box" formControlName='contract_starts_from'>
            </div>
            <div class="col">
                    <label for="exampleFormControlFile1">Contract Ends on <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="datetime-local" class="form-control code_box" formControlName='contract_ends_on'>
                </div>
        </div>
        <mat-progress-spinner *ngIf="loading" class="example-margin" color=primary mode="determinate" [value]=100>
        </mat-progress-spinner>
        <button style="margin-left: 40%;" *ngIf="!loading" mat-raised-button color="primary"
            [disabled]="!vehicle_register_from.valid" (click)="registerVehicle()">{{action}}</button>
    </form>
</mat-card>
